import React, { useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
import AIChat from './AIChat';

interface AgentChatDemoProps {
  agentName: string;
  agentPersonality: string;
}

const AgentChatDemo: React.FC<AgentChatDemoProps> = ({ agentName, agentPersonality }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsChatOpen(true)}
        className="flex items-center gap-2 bg-accent1 hover:bg-accent1/90 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
      >
        <MessageSquare size={16} />
        Chat with {agentName}
      </button>

      {isChatOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center p-4"
          style={{ zIndex: 9999 }}
        >
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => setIsChatOpen(false)}
          />
          {/* Modal Content */}
          <div className="relative w-full max-w-md" style={{ zIndex: 10000 }}>
            <AIChat
              agentName={agentName}
              agentPersonality={agentPersonality}
              onClose={() => setIsChatOpen(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AgentChatDemo;